export default "__VITE_ASSET__ChaeVqA4__"